import { client } from "./index";

// A store owner's limits and add-ons (backend routes/adminUsage.js)
export const getUsage = () => client.get("/admin/usage").then((res) => res.data);
// { kind: "storage" | "email", units, site }: answers { message, checkout } (or applied at once in development)
export const buyAddon = (addon) => client.post("/admin/usage/addons", addon).then((res) => res.data);
